export const updateProps = ({ commit }, props) => {
	commit('UPDATE_PROPS', props);
};
